import { Component, OnInit, ViewChild } from '@angular/core';
import { EventsService, UtilService } from 'src/app/shared/services';

@Component({
  selector: 'app-video-dm',
  templateUrl: './video-dm.component.html',
  styleUrls: ['./video-dm.component.scss']
})
export class VideoDmComponent implements OnInit {

  player;
  isMobile;
  isInitialPlay = true;
  isVideoEnded = false;
  isVideoReplayed = false;

  constructor(
    public util: UtilService,
    private events: EventsService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    setTimeout(() => {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
      window['onYouTubeIframeAPIReady'] = () => this.onYouTubeIframeAPIReady('IOgqKLMPAVc');
    }, 100);
  }

  onYouTubeIframeAPIReady(id) {
    this.player = new YT.Player('player', {
      width: this.isMobile ? '100%' : '622px',
      height: this.isMobile ? '203px' : '349px',
      playerVars: { autoplay: 0, rel: 0, controls: 1, modestbranding: 1, iv_load_policy: 3, showinfo: 0, loop: 1 },
      videoId: id,
      events: {
        'onStateChange': this.onPlayerStateChange.bind(this),
        'onReady': this.onPlayerReady.bind(this)
      }
    });
  }

  onPlayerStateChange(event) {
    if (event.data === 0) {
      if (!this.isVideoReplayed) {
        this.sendEvent('video ended');
        this.isVideoEnded = true;
      }
      this.isInitialPlay = true;
      this.isVideoReplayed = false;
    } else if (event.data === 1) {
      if (this.isInitialPlay) {
        if (!this.isVideoEnded) {
          this.sendEvent('video play');
        }
        this.isInitialPlay = false;
      } else if (this.isVideoEnded) {
        this.isVideoEnded = false;
        this.sendEvent('video replay');
      } else {
        this.sendEvent('video play');
      }
    } else if (event.data === 2) {
      this.sendEvent('video pause');
    }
  }

  onPlayerReady() {
    setTimeout(() => {
      this.player.playVideo();
      this.player.mute();
    }, 1000);
  }

  sendEvent(eName) {
    const pageViewSysEvent = {
      eventName: eName,
    };
    this.events.sendSystemEvent(pageViewSysEvent).subscribe(_ => _);
  }

}
